import AppState, { POPUPS, SCREENS } from "@/js/AppState";
import { observer } from "mobx-react-lite";
import ScaleManager from 'react-sdk/ScaleManager';

import Notifs from "@cmp/shared/Notifs/Notifs";
import PopupNotif from '@pops/PopupNotif/PopupNotif';
import ScreenFinal from "@scr/ScreenFinal/ScreenFinal";
import ScreenGame from "@scr/ScreenGame/ScreenGame";
import ScreenLoading from "@scr/ScreenLoading/ScreenLoading";
import ScreenVideo from '@scr/ScreenVideo/ScreenVideo';
import PopupsManager from 'react-sdk/PopupsManager';
// import PopupGroupAddUser from '../popups/PopupGroupAddUser/PopupGroupAddUser';
import PopupPeriod from '../popups/PopupPeriod/PopupPeriod';
import ScreenTestMg from '../screens/ScreenTestMg/ScreenTestMg';

import { IoMdMusicalNote } from "react-icons/io";
import SoundPlayer from "react-sdk/SoundPlayer";
import PopupIntro from "../popups/PopupIntro/PopupIntro";
import Button from "../shared/Button/Button";

import FtueHelper from "@/js/FtueHelper";
import { AiOutlineCompress, AiOutlineExpand } from "react-icons/ai";

import clsx from "clsx";
import { FaQuestion } from "react-icons/fa";
import PopupFtue from "../popups/PopupFtue/PopupFtue";
import PopupMentionLegales from "../popups/PopupMentionLegales/PopupMentionLegales";
import ScreenHomeAlt from "../screens/ScreenHomeAlt/ScreenHomeAlt";
import classes from './App.module.css';
import './global.css';

const App = () => {
  return (
    <>
      <div className={ clsx("App", classes.App, AppState.lockInteraction && classes.locked ) }  style={ScaleManager.style}>
        <div className={ classes.SideMenu} >

          <Button
          icon={ AppState.fullscreen ? <AiOutlineCompress  /> : <AiOutlineExpand />}
          onClick={() => AppState.toggleFullscreen()} />

          <Button
          classNameObjects={ SoundPlayer._mute ? "crossed" : "" }
          icon={<IoMdMusicalNote />}
          onClick={() => SoundPlayer.mute(!SoundPlayer._mute)} />

          { FtueHelper.displayftueButton &&
            <Button
              className={classes.ftue_btn}
              icon={<FaQuestion />}
              onClick={() => FtueHelper.handleftueButtonClick()} /> 
          }

        </div>

        { AppState.screen === SCREENS.LOADING && <ScreenLoading /> }

        {/* { AppState.screen === SCREENS.HOME && <ScreenHome /> } */}
        { AppState.screen === SCREENS.HOME && <ScreenHomeAlt /> }

        { AppState.screen === SCREENS.VIDEO && <ScreenVideo /> }
        { AppState.screen === SCREENS.GAME && <ScreenGame /> }

        { AppState.screen === SCREENS.ECRAN_FINAL && <ScreenFinal /> }

        { AppState.screen === SCREENS.TEST_MG && <ScreenTestMg /> }

        { PopupsManager.isOpened(POPUPS.LOADING) && <ScreenLoading /> }

        { PopupsManager.isOpened(POPUPS.INTRO) && <PopupIntro /> }
        { PopupsManager.isOpened(POPUPS.NOTIF) && <PopupNotif /> }
        { PopupsManager.isOpened(POPUPS.MENTION_LEGALES) && <PopupMentionLegales /> }
        {/* { PopupsManager.isOpened(POPUPS.LOCATION) && <PopupVue /> } */}
        { PopupsManager.isOpened(POPUPS.PERIOD) && <PopupPeriod /> }
        { PopupsManager.isOpened(POPUPS.FTUE) && <PopupFtue /> }

        <Notifs />
      </div>
    </>
  )
}

export default observer(App);
